function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "cross",
  transform: "translate(-230 -121)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1883",
  "data-name": "Group 1883",
  transform: "translate(-811.934 -563)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_307",
  "data-name": "Group 307",
  transform: "translate(1048.933 691)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_306",
  "data-name": "Group 306"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_305",
  "data-name": "Group 305"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_27",
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M36.641 28.248a.482.482 0 0 0 0-.68l-.495-.495a.481.481 0 0 0-.68 0l-3.266 3.27a.481.481 0 0 1-.68 0l-3.269-3.269a.482.482 0 0 0-.68 0l-.495.495a.481.481 0 0 0 0 .68l3.269 3.269a.481.481 0 0 1 0 .68l-3.269 3.269a.482.482 0 0 0 0 .68l.495.495a.481.481 0 0 0 .68 0l3.269-3.269a.481.481 0 0 1 .68 0l3.269 3.269a.482.482 0 0 0 .68 0l.495-.495a.481.481 0 0 0 0-.68L33.372 32.2a.481.481 0 0 1 0-.68z",
  "data-name": "Path 27",
  transform: "translate(-26.933 -26.933)"
}))))));

var SvgCross = function SvgCross(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCross, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross.db3b3a2e.svg";
export { ForwardRef as ReactComponent };